
import { useState, useEffect } from 'react'
import { useSearchParams, Link, useNavigate } from "react-router-dom"
import { AuthServices } from './util/authServices'
import { FaWhatsapp, FaPhone, FaTelegramPlane, FaAngleLeft, FaAngleRight, FaAngleDoubleLeft } from 'react-icons/fa';
import { Cargando } from './Cargando';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const DetailScort = () => {

    const navigate = useNavigate();

    const [searchParams] = useSearchParams();
    const id = searchParams.get('id');
    const origin = searchParams.get('origin');

    const [cargando, setCargando] = useState(true);
    const [scortObjet, setScortObjet] = useState(null);

    const [indexSlider, setIndexSlider] = useState(0)
    const [objectImages, setObjectImages] = useState([])
    const [currentImage, setCurrentImage] = useState('')

    useEffect(() => {
        if (id) {
            obtieneListaScorts();
        } else {
            navigate(`/`);
        }
    }, [id])

    const obtieneListaScorts = async () => {
        setCargando(true)
        const authServices = new AuthServices();
        try {
            const body = {
                "origen": "preliminar",
            }
            const response = await authServices.requestPost(body, 1);
            const { estado, mensaje, objeto } = response.data;
            if (estado) {
                const foundScort = objeto.find(s => String(s.idProcesamiento) === String(id));
                if (foundScort) {
                    setScortObjet(foundScort);
                    setObjectImages(foundScort.images || []);
                    setCurrentImage(foundScort.currentURL || '');
                }
            } else {
                toast(mensaje)
            }
            setCargando(false);
        } catch (error) {
            setCargando(false);
            toast("Error de comunicación")
        }
    }

    const chanceSlider = (indDot) => {
        setIndexSlider(indDot)
        setCurrentImage(objectImages[indDot].url)
        setObjectImages(objectImages.map((image, i) => {
            image.classDot = i === indDot ? 'div-dots-active' : 'div-dots'
            return image
        }))
    }

    const avanzaSliderImage = () => {
        let indDot = indexSlider + 1;
        if (indexSlider >= objectImages.length - 1) {
            indDot = 0
        }
        setIndexSlider(indDot)
        chanceSlider(indDot)
    }

    const retocedeSliderImage = () => {
        let indDot = indexSlider - 1;
        if (indexSlider <= 0) {
            indDot = objectImages.length - 1
        }
        setIndexSlider(indDot)
        chanceSlider(indDot)
    }

    const getTarifaDisplay = (valStr, multiplier) => {
        if (valStr === undefined || valStr === null || valStr === '') return '';
        const cleanStr = String(valStr).replace(/[\$\.\s]/g, '');
        const num = parseInt(cleanStr, 10);
        if (isNaN(num)) return valStr;
        const result = num * multiplier;
        return result.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    };

    if (cargando) {
        return <Cargando />
    }

    if (!scortObjet) {
        return <div className='text-white text-center mt-5'><h1>Scort no encontrada</h1> <Link to={controlRedirect()} className="btn btn-primary">Volver</Link></div>
    }

    const urlWhatsAppMessaje = `https://api.whatsapp.com/send/?phone=+57-${scortObjet.telefono}&text= Hola Infernal Paradise, quiero mas información sobre la modelo ${scortObjet.nombreArtistico} ${scortObjet.apellidoArtistico}, me gustaria contar con sus servicios`
    const urlLlamadaTelefonica = `tel:+57${scortObjet.telefono}`
    const urlTelegram = `https://t.me/${scortObjet.usuarioTelegram}`
    const detallesScort = scortObjet.detalles || []

    const controlRedirect = () => {
        if (origin) {
            if (origin === 'landingScort') {
                return '/'
            } else {
                return `/adminZone?origin=${origin}`
            }
        } else {
            return '/'
        }
    }

    return (
        <div className='div-modal-scort-info' style={{ paddingTop: "0rem", minHeight: "100vh", background: "#000" }}>
            <ToastContainer />
            <div className='padding-header-info'>
                <div className='div-info-scort-header'>
                    <div className="row p-0" style={{ height: "100%" }}>
                        <div className="col-2 col-sm-1 col-md-1 col-lg-2 p-0" >
                            <Link to={controlRedirect()} style={{ textDecoration: 'none' }}>
                                <div className='div-info-scort-titulo-link' >
                                    <FaAngleDoubleLeft className='btn-return-modal' />
                                    <p className='p-titulo-info-escort'>Volver </p>
                                </div>
                            </Link>
                        </div>
                        <div className="col-10 col-sm-10 col-md-10 col-lg-8 p-0" >
                            <div className='div-info-scort-titulo' >
                                <p className='text-info-scort-nombre'>{scortObjet.nombreArtistico} <font>{scortObjet.apellidoArtistico}</font> </p>
                            </div>
                        </div>
                        <div className="col-0 col-sm-1 col-md-1 col-lg-2 p-titulo-info-escort" ></div>
                    </div>
                </div>
            </div>
            <div className="row p-0" style={{ margin: "5rem 0rem 3rem 0rem" }}>
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 " >
                    <div className='div-target-details-padre' >
                        <div className='div-left-image' onClick={() => retocedeSliderImage()}>
                            <FaAngleLeft className='icon-angle' />
                        </div>
                        <div>
                            <img src={currentImage} alt='' className='img-scort-details'></img>
                        </div>
                        <div className='div-dots-padre' style={{ bottom: "35px" }}>
                            {
                                objectImages.map((image, i) => {
                                    return (
                                        <div key={i} className={image.classDot} onClick={() => chanceSlider(i)} ></div>
                                    )
                                })
                            }
                        </div>
                        <div className='div-right-image' onClick={() => avanzaSliderImage()} >
                            <FaAngleRight className='icon-angle' />
                        </div>
                    </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 " >
                    <div className='div-target-details-padre'>
                        <div className='div-info-scort-details'>
                            <p className=''>{scortObjet.descripcionScort} </p>
                        </div>
                    </div>
                    <div className='div-target-details-padre'>
                        <div className="row m-0 w-100 div-info-scort-details">
                            <div className='div-info-economica-padre'>
                                <p className='text-info-scort-nombre'><font>Tarifas</font></p>
                                <br />
                                <div className='div-info-economica'>
                                    <p >1 hora </p>
                                    <p >${getTarifaDisplay(scortObjet.tarifa1, 1)}</p>
                                </div>
                                <div className='div-info-economica'>
                                    <p >3 horas </p>
                                    <p >${getTarifaDisplay(scortObjet.tarifa2, 3)}</p>
                                </div>
                                <div className='div-info-economica'>
                                    <p >5 horas </p>
                                    <p >${getTarifaDisplay(scortObjet.tarifa3, 5)}</p>
                                </div>
                            </div>
                            <div className='div-info-economica-padre'></div>
                        </div>
                    </div>
                    <div className='div-target-details-padre'>
                        <div className='div-info-scort-details'>
                            <p className='text-info-scort-nombre'><font>Detalles </font> </p>
                        </div>
                        <div className='div-info-scort-details'>
                            {
                                detallesScort.map((detailObject, i) => {
                                    if (detailObject.llave === 'Fecha nacimiento') {
                                        var hoy = new Date();
                                        var cumpleanos = new Date(detailObject.valor);
                                        var edad = hoy.getFullYear() - cumpleanos.getFullYear();
                                        var m = hoy.getMonth() - cumpleanos.getMonth();

                                        if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
                                            edad--;
                                        }
                                        return (
                                            <div key={i} className="row m-0 div-row-info">
                                                <div className="col-5 ">
                                                    <p className='text-info-1'>Edad </p>
                                                </div>
                                                <div className="col-5 " >
                                                    <p className='text-info-2'> {edad}</p>
                                                </div>
                                            </div>
                                        )
                                    } else {
                                        return (
                                            <div key={i} className="row m-0 div-row-info">
                                                <div className="col-5 ">
                                                    <p className='text-info-1'>{detailObject.llave} </p>
                                                </div>
                                                <div className="col-5 " >
                                                    <p className='text-info-2'> {detailObject.valor}</p>
                                                </div>
                                            </div>
                                        )
                                    }
                                })
                            }
                        </div>
                    </div>
                    <br /><br />
                    <div className='div-info-contact-detail' >
                        <div>
                            <div className="row m-0">
                                <div className="col-6 col-sm-4 col-md-4 col-lg-4 p-0" >
                                    <a href={urlLlamadaTelefonica} rel="noreferrer" style={{ textDecoration: "none", color: "#FFF" }}>
                                        <div className='div-contact-1'>
                                            {scortObjet.telefono}
                                            <FaPhone />
                                        </div>
                                    </a>
                                </div>
                                <div className="col-6 col-sm-4 col-md-4 col-lg-4 p-0" >
                                    <a href={urlWhatsAppMessaje} target="_blank" rel="noreferrer" style={{ textDecoration: "none", color: "#FFF" }}>
                                        <div className='div-contact-2'>
                                            Whastapp
                                            <FaWhatsapp className='icon-whastapp-detail' />
                                        </div>
                                    </a>
                                </div>
                                <div className="col-12 col-sm-4 col-md-4 col-lg-4 p-0" >
                                    <a href={urlTelegram} rel="noreferrer" target="_blank" style={{ textDecoration: "none", color: "#FFF" }}>
                                        <div className='div-contact-3'>
                                            Telegram
                                            <FaTelegramPlane className='icon-whastapp-detail' />
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DetailScort
